"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.creator.title': 'Post Creator',
    'socialMediaPlan.creator.subtitle': 'Brief → AI preview → schedule',
    'socialMediaPlan.creator.selectPlatform': 'Select at least one platform',
    'socialMediaPlan.creator.fillBrief': 'Enter a topic and select platforms first',
    'socialMediaPlan.creator.aiError': 'AI generation failed. Try again or write manually.',
    'socialMediaPlan.creator.generate.title': 'Generate content tailored to each platform',
    'socialMediaPlan.creator.generate.desc': 'Fill in the brief in step 1, then generate AI preview.',
    'socialMediaPlan.creator.generateBtn': 'Generate with AI',
    'socialMediaPlan.creator.generating': 'Generating...',
    'socialMediaPlan.creator.manually': 'Write manually (no AI)',
    'socialMediaPlan.creator.regenerate': 'Regenerate all',
    'socialMediaPlan.creator.caption': 'Caption',
    'socialMediaPlan.creator.imagePrompt': 'Image prompt',
    'socialMediaPlan.creator.imageSection': 'Image',
    'socialMediaPlan.creator.imagePromptLabel': 'Generate with AI',
    'socialMediaPlan.creator.imageUploadLabel': 'Or upload your own image',
    'socialMediaPlan.creator.imageChoose': 'Choose image file',
    'socialMediaPlan.creator.imageClear': 'Remove image',
    'socialMediaPlan.creator.imagePromptPlaceholder': 'Describe the image to generate...',
    'socialMediaPlan.creator.generateImage': 'Generate Image',
    'socialMediaPlan.creator.imagePromptRequired': 'Enter an image prompt or topic first',
    'socialMediaPlan.creator.videoUpload': 'Video file (YouTube / TikTok)',
    'socialMediaPlan.creator.videoUploadHint': 'Required for YouTube and TikTok. Select the video file to publish.',
    'socialMediaPlan.creator.videoChoose': 'Choose video file',
    'socialMediaPlan.creator.videoUploadOnNext': 'Video will be uploaded when you click Next.',
    'socialMediaPlan.creator.videoReady': 'Video ready to publish.',
    'socialMediaPlan.creator.videoError': 'Failed to upload video. Please try again.',
    'socialMediaPlan.creator.imageError': 'Image generation failed. Try again.',
    'socialMediaPlan.creator.tip2026Title': '2026 trends tip',
    'socialMediaPlan.creator.tip2026Text': 'Short, authentic content with a clear CTA still drives the highest engagement. Carousels and video reels currently have the greatest organic reach.',
    'socialMediaPlan.creator.brandName': 'Your brand',
    'socialMediaPlan.creator.now': 'now',
    'socialMediaPlan.creator.like': 'Like',
    'socialMediaPlan.creator.comment': 'Comment',
    'socialMediaPlan.creator.share': 'Share',
    'socialMediaPlan.creator.fbPageLabel': 'Facebook page',
    'socialMediaPlan.creator.fbNoPages': 'No Facebook pages found. Connect your account in settings.',
    'socialMediaPlan.creator.liPageLabel': 'LinkedIn page',
    'socialMediaPlan.creator.ptBoardLabel': 'Pinterest board',
    'socialMediaPlan.creator.ptNoBoards': 'No Pinterest boards found. Connect your account in settings.',
    'socialMediaPlan.creator.postContent': 'Post content',
    'socialMediaPlan.creator.hashtags': 'Hashtags',
    'socialMediaPlan.creator.hashtagsHint': 'space separated',
    'socialMediaPlan.creator.aiInsightTitle': 'AI insight',
    'socialMediaPlan.creator.bestTime': 'Best time:',
    'socialMediaPlan.creator.charLimit': 'Character limit:',
    'socialMediaPlan.creator.videoRemove': 'Remove video',
};
